import { render, staticRenderFns } from "./MarkdownIt.vue?vue&type=template&id=4aaa6f4a"
import script from "./MarkdownIt.vue?vue&type=script&lang=js"
export * from "./MarkdownIt.vue?vue&type=script&lang=js"
import style0 from "./MarkdownIt.vue?vue&type=style&index=0&id=4aaa6f4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports